class MegaMenu {
    constructor() {
        this.navItems = document.querySelectorAll('.nav-link');
        this.megaMenuContainer = document.getElementById('mega-menu-container');
        this.initializeMenu();
    }

    initializeMenu() {
        this.navItems.forEach(item => {
            const placeholder = item.querySelector('.mega-menu-placeholder');

            if (placeholder) {
                const menuHandle = placeholder.dataset.menu;
                const megaMenu = document.getElementById('mega-menu-' + menuHandle);

                if (megaMenu) {
                    this.megaMenuContainer.appendChild(megaMenu);
                    this.addEventListeners(item, megaMenu);

                    const productContainer = megaMenu.querySelector('.mega-product-container');

                    this.initializeSplide(productContainer);
                }
            }
        });
    }

    initializeSplide(container) {
        const splide = new Splide(container, {
            type: 'slide',
            perPage: 5, 
            perMove: 1,
            gap: '36px',
            pagination: false,  
            arrows: false,
            drag: true,
            wheel: true,
            breakpoints: {
                1700: {
                    perPage: 4,  
                },
                1300: {
                    perPage: 3,  
                }
            },
        });
    
        const paginationContainer = document.createElement('div');
        paginationContainer.classList.add('splide-pagination');
        const line = document.createElement('div');
        line.classList.add('splide-pagination-line');
        paginationContainer.appendChild(line);
        container.parentElement.appendChild(paginationContainer);
    
        const updatePaginationLine = () => {
            const totalSlides = splide.Components.Slides.getLength();
            const visibleSlides = Math.min(splide.options.perPage, totalSlides);
            const percentage = (visibleSlides / totalSlides) * 100;
            const currentPosition = (splide.index / totalSlides) * 100;
    
            line.style.width = `${percentage}%`;
            line.style.left = `${currentPosition}%`;
        };
    
        splide.on('mounted move', updatePaginationLine);
    
        const updatePaginationVisibility = () => {
            const slidesCount = splide.Components.Slides.getLength();
    
            if (slidesCount <= splide.options.perPage) {
                paginationContainer.style.display = 'none';
            } else {
                paginationContainer.style.display = 'block';
            }
        };
    
        splide.on('mounted move', updatePaginationVisibility);
    
        const centerContentForSingleItem = () => {
            if (splide.Components.Slides.getLength() === 1) {
                container.querySelector('.splide__list').style.justifyContent = 'center'; 
            } else {
                container.querySelector('.splide__list').style.justifyContent = 'flex-start'; 
            }
        };
    
        splide.on('mounted move', centerContentForSingleItem);
    
        splide.mount();
    }    

    addEventListeners(item, megaMenu) {
        item.addEventListener('mouseenter', () => {
            this.showMenu(megaMenu);
        });

        item.addEventListener('mouseleave', () => {
            setTimeout(() => {
                if (!megaMenu.matches(':hover') && !item.matches(':hover')) {
                    this.hideMenu(megaMenu);
                }
            }, 100);
        });

        megaMenu.addEventListener('mouseleave', () => {
            setTimeout(() => {
                if (!megaMenu.matches(':hover') && !item.matches(':hover')) {
                    this.hideMenu(megaMenu);
                }
            }, 100);
        });

        megaMenu.addEventListener('mouseenter', () => {
            this.showMenu(megaMenu);
        });
    }

    showMenu(megaMenu) {
        megaMenu.classList.add('show');
    }

    hideMenu(megaMenu) {
        megaMenu.classList.remove('show');
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new MegaMenu();
});
